<template>
  <div class="PauseSubscription">
    <p class="subscription_button" @click="$bus.$emit('open-modal', 'replenishmentPause')">
      {{ $t('subscription_details.accordion.pauseReplenshipment.subAccordion.title', 'Pause replenishment subscription') }}
    </p>
    <app-modal name="replenishmentPause" width="376px" min-height="450px" class="pause_subscription-modal" @after-closed="emptyCancelData">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.title', 'Pause subscription') }}
        </h3>

        <div class="modal-content" :class="{'addCalender': pauseSubscription === 'Until specific date'}">
          <p class="subTitle">
            {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.subTitle', 'Pause my subscription...') }}
          </p>

          <div class="selectPauseTime">
            <div class="selectRadio">
              <ul>
                <li
                  v-for="(item, index) in PauseTime"
                  :key="index"
                  @click="addClass(index)">
                  <span
                    class="payment-method_radio"
                    :id="item.id"
                    :class="{'payment-method_radioExtend' : currentIndex === index}"
                    ref="pauseSubscription"></span>
                  <span>{{ item.text }}</span>
                </li>
              </ul>
              <app-date-picker v-if="pauseSubscription === 'Until specific date'" @getDate="getSpecficDate"/>
            </div>
          </div>

          <div class="modal-button-warpper flex-column">
            <app-button
              type="submit"
              @click="replenishmentPauseConfirm"
              :disabled="!(pauseSubscription && (pauseSubscription === 'Indefinitely' || (pauseSubscription === 'Until specific date' && !!specificDate)))"
            >
              {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.button.pause', 'Pause subscription') }}
            </app-button>

            <app-button @click="replenishmentPauseCancel">
              {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.button.cancel', 'Cancel') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
    <app-modal name="confirmIndefinitelyPauseSubscription" width="545px" min-height="252px" @after-closed="emptyCancelData">
      <div class="v--modal-content">
        <h3 class="modal-title">
        </h3>
        <div class="modal-content">
          <p class="title">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.indefinitelyPause.title', 'Are you sure you want to pause your subscription?') }}</p>
          <p class="tips">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.indefinitelyPause.tips', '• Payment and shipments will be stopped immediately.') }}</p>
          <p class="tips">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.indefinitelyPause.subTips', '• You can manually resume your subscription anytime.') }}</p>

          <div class="modal-button-warpper modal-button">
            <app-button
              @click="cancelIndefinitelyPauseSubscription"
              class="cancel_openModal"
            >
              {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.button.cancel', 'Cancel') }}
            </app-button>

            <app-button
              type="submit"
              @click.prevent="PauseSubscriptionTask.run()"
              :is-loading="PauseSubscriptionTask.isActive">
              {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.button.pause', 'Pause subscription') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
    <app-modal name="confirmSpecficDatePauseSubscription" width="545px" min-height="200px" @after-closed="emptyCancelData">
      <div class="v--modal-content">
        <h3 class="modal-title">
        </h3>
        <div class="modal-content">
          <p class="title">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.specficDatePause.title', 'Are you sure you want to pause your subscription?') }}</p>
          <p class="tips">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.specficDatePause.tipsOne', '• Payment and shipments will be stopped immediately.') }} </p>
          <p class="tips">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.specficDatePause.tipsTwo', '• Your subscription will automatically resume on ') }} <b>{{ specificDateFormat }}</b> </p>
          <p class="tips">{{ $t('subscription_details.accordion.pauseReplenshipment.popUp.specficDatePause.tipsThree', '• You can manually resume your subscription anytime.') }}</p>

          <div class="modal-button-warpper modal-button">
            <app-button
              @click="cancelSpecficDatePauseSubscription"
              class="cancel_openModal"
            >
              {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.button.cancel', 'Cancel') }}
            </app-button>

            <app-button
              type="submit"
              @click.prevent="PauseSubscriptionTask.run()"
              :is-loading="PauseSubscriptionTask.isActive">
              {{ $t('subscription_details.accordion.pauseReplenshipment.popUp.button.pause', 'Pause subscription') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>
<script>
  import { extractErrorMessage } from '@/utilities/common'
  import Vue from 'vue'

  export default {
    name: 'replenshipment-pause-subscription',
    data () {
      return {
        PauseTime: [
          {
            text: this.$t('subscription_details.accordion.pauseReplenshipment.popUp.pauseOption.indefinitely', 'Indefinitely'),
            id: 'Indefinitely'
          },
          {
            text: this.$t('subscription_details.accordion.pauseReplenshipment.popUp.pauseOption.specificDate', 'Until specific date'),
            id: 'Until specific date'
          }
        ],
        step1Show: false,
        currentIndex: -1,
        pauseSubscription: '',
        specificDate: null,
        specificDateFormat: null,
        pauseActions: null
      }
    },

    props: {
      subscriptionNumber: {
        type: String,
        required: true
      }
    },

    methods: {
      addClass (index) {
        if (index !== this.currentIndex) {
          this.currentIndex = index
          this.step1Show = true
          this.pauseSubscription = this.$refs.pauseSubscription[index].id
        } else {
          this.currentIndex = -1
          this.step1Show = false
          this.pauseSubscription = ''
        }
      },

      replenishmentPauseConfirm () {
        if (this.pauseSubscription === 'Indefinitely') {
          this.$bus.$emit('open-modal', 'confirmIndefinitelyPauseSubscription')
        } else if (this.pauseSubscription === 'Until specific date') {
          this.$bus.$emit('open-modal', 'confirmSpecficDatePauseSubscription')
        }
        this.$bus.$emit('close-modal', 'replenishmentPause')
      },

      getSpecficDate (date) {
        this.specificDateFormat = `${date.toDateString().split(' ')[1]} ${date.getDate()}, ${date.getFullYear()}`
        this.specificDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      },

      emptyCancelData () {
        this.step1Show = false
        this.specificDateFormat = ''
        this.specificDate = ''
        this.currentIndex = -1
        this.pauseSubscription = ''
      },

      replenishmentPauseCancel () {
        this.$bus.$emit('close-modal', 'replenishmentPause')
        this.emptyCancelData()
      },

      cancelIndefinitelyPauseSubscription () {
        this.$bus.$emit('close-modal', 'confirmIndefinitelyPauseSubscription')
        this.emptyCancelData()
      },

      cancelSpecficDatePauseSubscription () {
        this.$bus.$emit('close-modal', 'confirmSpecficDatePauseSubscription')
        this.emptyCancelData()
      }
    },

    tasks (t) {
      return {
        PauseSubscriptionTask: t(async function () {
          if (this.pauseSubscription === 'Indefinitely') {
            // API call
            this.pauseActions = this.pauseSubscription
            await Vue.api.subscription.indefinitelyPauseSubscription(this.subscriptionNumber)
            this.cancelIndefinitelyPauseSubscription()
          } else if (this.pauseSubscription === 'Until specific date') {
            // API call
            this.pauseActions = this.pauseSubscription
            await Vue.api.subscription.specificDatePauseSubscription(this.subscriptionNumber, this.specificDate)
            this.cancelSpecficDatePauseSubscription()
          }
          this.$router.push({
            name: 'my-account'
          })
          this.$notify({
            type: 'success',
            title: 'Pause subscription successfully!'
          })
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        })
      }
    }
  }
</script>
<style lang="scss">
  .PauseSubscription {
    .pause_subscription-modal {
      .v--modal-container {
        padding: .2rem;

        .modal-title {
          padding-bottom: .4rem;
        }
      }

      .closeButton {
        top: .2rem;
      }

      .title {
        line-height: .24rem;
        color: #212121;
        font-size: .2rem;
        font-weight: bold;
        margin-bottom: .32rem;
      }

      .tips {
        line-height: .24rem;
        font-size: .16rem;
        color: #212121;
      }

      .AppButton {
        background-color: #1474a4;
      }
    }

    .modal-button {
      margin: .32rem 0 .1rem !important;
      justify-content: flex-end !important;

      .AppButton {
        width: auto !important;
        padding: .09rem .4rem;
      }

      .cancel_openModal {
        margin-right: .1rem;
        background-color: #fff;
        color: $blue;
      }
    }

    .addCalender {
      min-height: 5rem !important;
    }
  }
</style>
